import Vue from 'vue'
import {stepIconName, stepColor, stepTextColor, durationText, formatDate} from 'js/lib/planner'
import template from './_route-item.pug'

export default Vue.extend({
  template: template(),
  props: {
    routeData: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      animation: undefined,
      initialWidth: undefined,
      dragged: false,
      detail: {
        deltaX: 0,
        deltaY: 0
      }
    }
  },
  computed: {
    /* Si el elemento tiene que tener animación, se le pondrá una clase para animarla
    *  u otra para parar la animación
    */
    getAnimationClass() {
      if (this.animation !== undefined) {
        return this.animation ? 'animate' : 'stop-animate'
      }

      return ''
    },
    // Asigna los valores CSS4 que debe tener la animación
    getAnimationStyle() {
      if (this.animation !== undefined) {
        const item = this.$refs.routes

        return `--margin: ${this.initialWidth - item.offsetWidth}px`
      }

      return ''
    },
    // Asigna el punto de la mano si no tiene animación y por tanto, drag
    getPointerClass() {
      return !this.initialWidth ? 'pointer' : ''
    },
    /* Si el elemento se está draggeando, se le aplica la clase para desactivar
    * los eventos asociados al elemento
    */
    getEventsClass() {
      return this.dragged ? 'no-events' : ''
    },
    /* Asigna el dragable si es movil */
    isDragEnabled() {
      return this.$store.state.device === 'desktop'
    }
  },
  created() {
    this.$nextTick(() => {
      const item = this.$refs.routes
      const lastChild = item.lastChild
      const paddingRight =
        window.getComputedStyle(lastChild, null).getPropertyValue('padding-right').slice(0, -2)

      /* Si el último elemento del div que contiene las rutas sobrepasa el ancho
      * del padre, se le asigna animación y guardamos un width inicial
      */
      if (item.offsetWidth < lastChild.offsetLeft + lastChild.offsetWidth - paddingRight) {
        this.animation = true
        this.initialWidth = item.offsetWidth
      }
    })
  },
  methods: {
    stepIconName,
    durationText,
    formatDate,
    enableAnimationClass() {
      if (this.initialWidth) {
        this.animation = true
      }
    },
    removeAnimationClass() {
      this.animation = false
    },
    disableClickClass() {
      this.dragged = true
    },
    enableClickClass() {
      this.dragged = false
    },
    showLineItem(step) {
      return step.transit && step.transit.line
    },
    itemColor(step) {
      return {
        color: stepTextColor(step),
        backgroundColor: stepColor(step)
      }
    },
    lineShortName(step) {
      const {short_name: shortName, name} = _.get(step, 'transit.line') || {}

      return shortName || name
    }
  }
})
